<!-- 二级标题 -->
<template>
  <div class="titleTow">
    <div class="max-title">{{englithA}}<span>{{englithTitle}}</span></div>
    <div class="chinaname">{{changname}}</div>
    <div class="iconaddress">
      <div class="addicon"><img src="@/assets/erjiicon.png" alt=""></div>
      <div class="addname">您当前所在位置：首页/</div>
      <div class="addname">{{addone}}/</div>
      <div class="addtow">{{addtow}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      // englithA:'A',
      // englithTitle:'fter-sales service',
    }
  },
  props:{
    englithTitle:{
      type:String,
      default:"",
    },
    englithA:{
      type:String,
      default:"",
    },
    changname:{
      type:String,
      default:"",
    },
    addone:{
      type:String,
      default:"",
    },
    addtow:{
      type:String,
      default:"",
    },
  }
}
</script>
<style lang="scss">
.titleTow{
  width: 1300px;
  margin: 0 auto;
  padding-top: 10px;
}
.max-title{
  font-size: 50px;
  span{
    font-size: 30px;
  }
}
.chinaname{
  margin-top: 13px;
  font-size: 20px;
  margin-left: 64px;
}
.iconaddress{
  display: flex;
  margin-left: 64px;
  margin-top: 53px;
  align-items: center;
  .addicon{
    width: 22px;
    height: 22px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .addname{
    font-size: 16px;
    color: #A1A1A1;
  }
  .addtow{
    font-size: 16px;
    color: #000000;
  }
}
@media (min-width: 1200px) and (max-width: 1300px){
  .titleTow{
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SecondTitle.vue